import groupedRequestDetailsStore from "../store/store";
import { IGroupedOpenShiftRequestEntity } from "sh-models";
import { mutatorAction } from "satcheljs";

export default mutatorAction('SET_GROUPED_REQUEST_IN_STORE', function setGroupedRequestInStore(groupedOpenShiftRequest: IGroupedOpenShiftRequestEntity) {
    if (groupedRequestDetailsStore) {
        groupedRequestDetailsStore.groupedOpenShiftRequest = groupedOpenShiftRequest;
    }
});
